let bqjUrl = ""; //这里是一个默认的url，可以没有
let svipUrl =""; //
switch (process.env.NODE_ENV) {
    case 'pre':
        bqjUrl = "https://ganganback.bqj.cn" // 测试环境
        svipUrl = "https://ganganback.bqj.cn"
        break
    case 'test':
        bqjUrl = "https://ganganback.bqj.cn" // 测试环境
        svipUrl = "https://ganganback.bqj.cn"
        break
    case 'production':
        bqjUrl = "https://back.qh-copyright.cn" //生产环境
        svipUrl =  "https://back.qh-copyright.cn"
        // bqjUrl = "https://ganganback.bqj.cn" // 测试环境
        // svipUrl = "https://ganganback.bqj.cn"
        break

    default:
        bqjUrl = "https://back.qh-copyright.cn" //生产环境
        svipUrl =  "https://back.qh-copyright.cn"
        break
}

export{
    bqjUrl,
    svipUrl
};